<script setup lang="ts">
import { computed } from 'vue';
import { useUsageAmount } from '@eureka/edition-upgrade/src/composables/use-usage-amount';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { usageAmount, fetchUsageAmount } = useUsageAmount();

const isSupport = computed(() => {
    return usageAmount.value.ai_disclosure_generate?.support || false;
});

const maxUsageAmount = computed(() => {
    return usageAmount.value.ai_disclosure_generate?.max_amount || -1;
});

const currentUsageAmount = computed(() => {
    return usageAmount.value.ai_disclosure_generate?.current_amount || -1;
});

const leftUsageAmount = computed(() => {
    return Math.max(maxUsageAmount.value - currentUsageAmount.value, 0);
});

const needDisplayAmount = computed(() => {
    return maxUsageAmount.value !== -1 && currentUsageAmount.value !== -1 && isSupport.value;
});

fetchUsageAmount();

</script>

<template>
    <div class="disclosure-amount mt-2 text-center" v-show="needDisplayAmount">
        {{ t('amount.residueCount') }}
        <span class="text-primary">{{ leftUsageAmount }} / {{ maxUsageAmount }}</span>
        {{ t('amount.unit') }}
    </div>
</template>

<style lang="scss">

</style>
